/**
 * @generated SignedSource<<35f2f719195e289f892d719bee297e38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditFlexLicenseDefinitionAdminMutationInput = {
  clientMutationId?: string | null;
  data: FlexLicenseDefinitionDataInput;
  licenseDefinitionId: string;
};
export type FlexLicenseDefinitionDataInput = {
  excludedNodeIds: ReadonlyArray<string>;
  includedNodeIds: ReadonlyArray<string>;
  name: string;
};
export type editFlexLicenseDefinitionButton_editFlexLicenseDefinitionMutation$variables = {
  input: EditFlexLicenseDefinitionAdminMutationInput;
};
export type editFlexLicenseDefinitionButton_editFlexLicenseDefinitionMutation$data = {
  readonly Admin: {
    readonly LicenseDefinition: {
      readonly editFlexLicenseDefinitionAdminMutation: {
        readonly licenseDefinition: {
          readonly " $fragmentSpreads": FragmentRefs<"editFlexLicenseDefinitionButton_LicenseDefinitionFragment">;
        };
      } | null;
    };
  };
};
export type editFlexLicenseDefinitionButton_editFlexLicenseDefinitionMutation = {
  response: editFlexLicenseDefinitionButton_editFlexLicenseDefinitionMutation$data;
  variables: editFlexLicenseDefinitionButton_editFlexLicenseDefinitionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rootId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "editFlexLicenseDefinitionButton_editFlexLicenseDefinitionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LicenseDefinitionAdminMutationSchema",
            "kind": "LinkedField",
            "name": "LicenseDefinition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditFlexLicenseDefinitionAdminMutationPayload",
                "kind": "LinkedField",
                "name": "editFlexLicenseDefinitionAdminMutation",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LicenseDefinition",
                    "kind": "LinkedField",
                    "name": "licenseDefinition",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "editFlexLicenseDefinitionButton_LicenseDefinitionFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "editFlexLicenseDefinitionButton_editFlexLicenseDefinitionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LicenseDefinitionAdminMutationSchema",
            "kind": "LinkedField",
            "name": "LicenseDefinition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditFlexLicenseDefinitionAdminMutationPayload",
                "kind": "LinkedField",
                "name": "editFlexLicenseDefinitionAdminMutation",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LicenseDefinition",
                    "kind": "LinkedField",
                    "name": "licenseDefinition",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LicenseDefinitionRootInfo",
                                "kind": "LinkedField",
                                "name": "includedNodeIds",
                                "plural": true,
                                "selections": (v2/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LicenseDefinitionRootInfo",
                                "kind": "LinkedField",
                                "name": "excludedNodeIds",
                                "plural": true,
                                "selections": (v2/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "FlexLicenseDefinitionData",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f7905b73a04e955bce9eca5adc22178f",
    "id": null,
    "metadata": {},
    "name": "editFlexLicenseDefinitionButton_editFlexLicenseDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation editFlexLicenseDefinitionButton_editFlexLicenseDefinitionMutation(\n  $input: EditFlexLicenseDefinitionAdminMutationInput!\n) {\n  Admin {\n    LicenseDefinition {\n      editFlexLicenseDefinitionAdminMutation(input: $input) {\n        licenseDefinition {\n          ...editFlexLicenseDefinitionButton_LicenseDefinitionFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment editFlexLicenseDefinitionButton_LicenseDefinitionFragment on LicenseDefinition {\n  id\n  data {\n    __typename\n    ... on FlexLicenseDefinitionData {\n      name\n      includedNodeIds {\n        rootId\n        title\n      }\n      excludedNodeIds {\n        rootId\n        title\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f3aa18fe4e1d571d26f790885f604f8";

export default node;
